module.exports = __webpack_public_path__ + "img/middlepic03.3d544b0e.jpg";